module.exports = ".button-bar {\n    display: none !important;\n}"